import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './statistik.module.scss';
import {StatistikViewComponentConfig} from './component/statistikView/statistikView';
import {statistikRun} from './statistik.route';


export const SerfWebStatistik = angular.module('serfWeb.statistik', [SerfWebCore.name])
    .component('dvStatistikView', new StatistikViewComponentConfig())
    .run(statistikRun);

export default SerfWebStatistik;



// WEBPACK FOOTER //
// ./src/app/statistik/statistik.module.ts